import React, { useEffect } from 'react';
import './Footer.css';
import $ from 'jquery';

const Footer = () => {

    useEffect(() => {

        $("#btnaboutMe_b").click(function() {
            $('html, body').animate({
                scrollTop: $("#aboutMe").offset().top
            }, 2000);
        });
        $("#btnwork_b").click(function() {
            $('html, body').animate({
                scrollTop: $("#work").offset().top
            }, 2000);
        });
        $("#btnblog_b").click(function() {
            $('html, body').animate({
                scrollTop: $("#blog").offset().top
            }, 2000);
        });
        $("#btncontact_b").click(function() {
            $('html, body').animate({
                scrollTop: $("#contact").offset().top
            }, 2000);
        });
 
    }, [])

    return(
        <div className="footer">
            <div className="footer-box">
                <div className="footer-content">
                    <ul>
                        <li id="btnaboutMe_b">O mnie</li>
                        <li id="btnwork_b">Prace</li>
                        <li id="btnblog_b">Blog</li>
                        <li id="btncontact_b">Kontakt</li>
                    </ul>
                </div>
                <div className="footer-logo">
                    <img alt="logo" src="/assets/images/logodiamontdvl.png" />
                </div>
            </div>    
        </div>
    );
}

export default Footer;